<script lang="ts" setup>
import icSaved from '@/assets/img/icon/ic-saved.svg';
import icSave from '@/assets/img/icon/ic-save.svg';
import { AppButton } from '@/components/base';

const { showSnackbar } = useSnackbar();
const props = defineProps<{
  isSaved: boolean;
  disabled: boolean;
}>();
const report = (): void => {
  showSnackbar({
    text: 'WIP',
    state: 'warning',
  });
};
</script>
<template>
  <AppButton  color="color" variant="flat" icon="mdi-close" class="report-job-listing" @click="saveJob" v-if="!isSaved && !disabled">
    <v-img size="small" width="22" height="22" :src="icSave" />
  </AppButton>
  <AppButton color="color" variant="flat" icon="mdi-close" class="report-job-listing" @click="saveJob" v-else-if="!disabled">
    <v-img size="small" width="30" height="30" :src="icSaved" />
  </AppButton>
</template>
<style lang="scss" scoped>
.report-job-listing {
  max-width: 32px;
}
</style>
